import { render, staticRenderFns } from "./op-purchase-plan-add-for-delivery.vue?vue&type=template&id=52f5a2b6&scoped=true&"
import script from "./op-purchase-plan-add-for-delivery.vue?vue&type=script&lang=js&"
export * from "./op-purchase-plan-add-for-delivery.vue?vue&type=script&lang=js&"
import style0 from "./op-purchase-plan-add-for-delivery.vue?vue&type=style&index=0&id=52f5a2b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f5a2b6",
  null
  
)

export default component.exports